import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import './styles/index.scss'

import Root from './containers/Root'

export default Root

if (typeof document !== 'undefined') {
  const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate
  const render = Comp => {
    renderMethod(
      <AppContainer>
        <Comp />
      </AppContainer>,
      document.getElementById('root'),
    )
  }

  render(Root)

  if (module.hot) {
    module.hot.accept('./containers/Root', () => {
      render(require('./containers/Root').default)
    })
  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/index.js